// ---------------------------------------------------------------------------
// Earthing grid layout constants (meters)
// ---------------------------------------------------------------------------
/** Minimum allowed distance from the base earthing loop to the apparatus foundation. */
export const BASE_MIN_DIST = 0.2;
/** Maximum allowed distance from the base earthing loop to the apparatus foundation. */
export const BASE_MAX_DIST = 1.;
/** Minimum allowed distance from the earthing grid to the apparatus foundation. */
export const GRID_MIN_DIST = 0.1;
/** Maximum allowed distance from the earthing grid to the apparatus foundation. */
export const GRID_MAX_DIST = 1.;
/** Step size used when testing prospective grid line positions. */
export const GRID_RES = 0.01;
